import { fromJS } from "immutable";

import {
    SET_ERA_CONTENT,
} from "./../actions/index";

const initialState = fromJS({
    era: null,
});

function globalReducer(state = initialState, action) {
    switch (action.type) {
    case SET_ERA_CONTENT:
        return state.set("era", action.data);
    default:
        return state;
    }
}

export default globalReducer;



// WEBPACK FOOTER //
// ./src/reducers/global.js